export interface Agent {
  id: string;
  client_id: string;
  name: string;
  voice: string;
  identity: string;
  role: string;
  background_audio: string;
  avatar_id: string;
  default_greetings: string;
  /** How the agent addresses the customer in French. Missing means "formal". */
  address_register?: AddressRegister;
  /** How the agent sounds: tone, and on an expressive voice pace and tags. Missing means "professional". */
  temperament?: Temperament;
  can_receive_transfers?: boolean;
  debug_tones?: boolean;
  /** Experimental, SYSADMIN-only: the head of the answer is proposed while the caller speaks. */
  anticipated_start?: boolean;
  /** Experimental, SYSADMIN-only: voice played this many times faster than rendered (1 = untouched, unset = DEFAULT_PLAYBACK_RATE). */
  playback_rate?: number;
  /** Serve an ElevenLabs voice with its expressive model (v4 Turbo: audio tags, livelier delivery). */
  expressive_voice?: boolean;
  created_at?: string;
  updated_at?: string;
}

/** The playback-rate options the agent form offers (experimental). */
export const PLAYBACK_RATES = [1, 1.05, 1.1, 1.15, 1.2, 1.25];

/** What an agent that never set its playback rate plays at (mirrors the backend's). */
export const DEFAULT_PLAYBACK_RATE = 1;

export type AddressRegister = "formal" | "informal" | "adaptive";

/** The address-register options, in the order the agent form lists them. */
export const ADDRESS_REGISTERS: { value: AddressRegister; label: string }[] = [
  { value: "formal", label: "agents.form.addressRegisterFormal" },
  { value: "informal", label: "agents.form.addressRegisterInformal" },
  { value: "adaptive", label: "agents.form.addressRegisterAdaptive" },
];

export type Temperament = "professional" | "warm" | "energetic";

/** The temperaments (backend `platform/speech/temperaments.ts`), in the order the agent form lists them. */
export const TEMPERAMENTS: { value: Temperament; label: string }[] = [
  { value: "professional", label: "agents.form.temperamentProfessional" },
  { value: "warm", label: "agents.form.temperamentWarm" },
  { value: "energetic", label: "agents.form.temperamentEnergetic" },
];
